module.exports = __webpack_public_path__ + "img/0xc1a56650f12420405c5b7e2634eb3779a0c3e396.f9354b97.png";